module.exports = __webpack_public_path__ + "img/Color S132.08324ad9.jpg";